import {combineReducers} from 'redux';
import {routerReducer} from 'react-router-redux';
import {reducer as formReducer} from 'redux-form';

import auth from './auth';
import data from './data';
import content from './content';

export default combineReducers({
    auth,
    routing: routerReducer,
    data,
    content,
    form: formReducer
})








// WEBPACK FOOTER //
// ./src/reducers/index.js